import React from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';
import { List } from 'immutable';
import UMOGridItemOverlay from './UMOGridItemOverlay';
import { UMOGalleryUMODraggable, getDragGhostImage } from '../../utils/draggables';
import { SearchParams } from '../../utils/searchUtils';
import UMOThumbnail from '../UMOThumbnail';
import appConfig from '../../appConfig';

const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
});

// todo: refactor. remove isNotJustified, use classNameModifier -- i.e. same as workspace preview
function UMOGridItem({
  umo,
  customMetatag,
  onDetailViewClick,
  toggleFullImageView,
  isNotJustified,
  isWorkspaceItem,
  highlightSetID,
  isUMOGalleryWorkspace,
  isSelected,
  isLoaded,
  classModifier,
  overlayClassModifier,
  retrieveAlternateUMOs,
  dispatch,
  selectedWorkspaceData,
  searchParams,
  selectedUMOIDs,
  isSelectAll,
  workspaceCardsViewTimes,
  galleryType,
  isSmallGrid,
  isSelectableItem,
  isOptionalIconsOverflow,
}) {
  // eslint-disable-next-line no-underscore-dangle
  const hasAlternates = umo._data.re > 1;
  const isRestricted = umo.thumbnail._data.$.restricted === 'T';
  const dragHandler = (evt) => {
    $('.main__search-bar').css('pointer-events', 'none');
    const workspaceID =
      isUMOGalleryWorkspace &&
      selectedWorkspaceData &&
      selectedWorkspaceData.id;
    const selectionData = {
      searchParams: searchParams && searchParams.toSearchQuery(),
      selectedUMOIDs,
      isSelectAll,
      categoryID: searchParams?.get('tagList')?.[0]?.value,
    };
    evt.dataTransfer.setDragImage(getDragGhostImage(), -10, -10);
    evt.dataTransfer.setData(
      'text/plain',
      new UMOGalleryUMODraggable(
        evt.target.dataset.item,
        !!workspaceID,
        workspaceID ? { workspaceID, ...selectionData } : { ...selectionData }
      ).stringify()
    );
  };

  const dragEndHandler = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
    $('.main__search-bar').removeAttr('style');
  };

  const dragEnterHandler = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
  };

  const dragOverHandler = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
  };

  const dropHandler = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
  };

  let customMeta = '';
  let customMetaValue = '';
  if (customMetatag) {
    const customTag = umo.metadataList.getMetadata(customMetatag);
    if (customTag && (customTag.value || appConfig.customClassMetatagAllowEmptyValues)) {
      customMetaValue = customTag.value?.toLowerCase() || 'null-value';
      customMeta = (
        <span
          className={`umo-grid-item--customIcon ${customMetaValue} ${
            hasAlternates ? 'with-alternates' : ''
          }`}
        />
      );
    }
  }

  let isUnseenUpdate = false;
  if (workspaceCardsViewTimes) {
    const updateTime = _.find(workspaceCardsViewTimes.viewtimes, {
      umo_id: parseInt(umo.id),
    });
    if (updateTime) {
      isUnseenUpdate = new Date(updateTime.viewtm).valueOf() < new Date(updateTime.cardtm).valueOf();
    }
  }

  const onAlternatesClick = (e) => {
    // todo: refactor. correct select toggle should probably be given
    retrieveAlternateUMOs(umo.id);
    e.stopPropagation();
  };

  return (
    <div
      className={classNames(
        'umo-grid-item',
        'entry-visible', // Hack to stop justifiedGallery from hiding the image on update.
        classModifier,
        {
          'umo-grid-item--noj': isNotJustified,
          'umo-grid-item--sm': isSmallGrid,
          'umo-grid-item--selected': !isNotJustified && isSelected,
          'umo-grid-item--loaded': isLoaded,
        }
      )}
      draggable={!isWorkspaceItem}
      onDrop={dropHandler}
      onDragStart={dragHandler}
      onDragEnd={dragEndHandler}
      data-item={umo.id}
      onDragEnter={dragEnterHandler}
      onDragOver={dragOverHandler}
    >
      {customMeta}
      <UMOThumbnail umo={umo} isSelectableItem={isSelectableItem} />
      <UMOGridItemOverlay
        isOptionalIconsOverflow={isOptionalIconsOverflow}
        onDetailViewClick={onDetailViewClick}
        overlayClassModifier={overlayClassModifier}
        toggleFullImageView={toggleFullImageView}
        isNotJustified={isNotJustified}
        isSmallGrid={isSmallGrid}
        isWorkspaceItem={isWorkspaceItem}
        highlightSetID={highlightSetID}
        isUMOGalleryWorkspace={isUMOGalleryWorkspace}
        isSelected={isSelected}
        dispatch={dispatch}
        umo={umo}
        selectedWorkspaceData={selectedWorkspaceData}
        isUnseenUpdate={isUnseenUpdate}
        galleryType={galleryType}
        isRestricted={isRestricted}
      />
      {hasAlternates ? (
        <span
          onClick={onAlternatesClick}
          className={classNames(
            'umo-grid-item__overlay-alternates',
            isSmallGrid ? 'sm-overlay' : ''
          )}
        >
          <i
            className={classNames(
              isSelected
                ? 'umo-grid-item__overlay-alternates--checked'
                : 'umo-grid-item__overlay-alternates-icon'
            )}
          />
        </span>
      ) : null}
    </div>
  );
}

UMOGridItem.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  selectedUMOIDs: PropTypes.instanceOf(List),
  searchParams: PropTypes.instanceOf(SearchParams),
  onDetailViewClick: PropTypes.func,
  toggleFullImageView: PropTypes.func,
  retrieveAlternateUMOs: PropTypes.func,
  classModifier: PropTypes.string,
  overlayClassModifier: PropTypes.string,
  isNotJustified: PropTypes.bool,
  isSmallGrid: PropTypes.bool,
  isWorkspaceItem: PropTypes.bool,
  highlightSetID: PropTypes.string,
  isUMOGalleryWorkspace: PropTypes.bool,
  isSelected: PropTypes.bool,
  isSelectAll: PropTypes.bool,
  isLoaded: PropTypes.bool,
  dispatch: PropTypes.func,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  customMetatag: PropTypes.string,
  workspaceCardsViewTimes: PropTypes.shape({
    catid: PropTypes.string,
    usernm: PropTypes.string,
    viewtimes: PropTypes.array,
  }),
  galleryType: PropTypes.string,
  isSelectableItem: PropTypes.bool,
  isOptionalIconsOverflow: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(UMOGridItem);
